import { PixelRatio, Platform } from 'react-native'
import { serializeParams } from './query'

export const isObject = object => {
  return typeof object === 'object' && object !== null && !Array.isArray(object)
}

export const getDimensions = (queryValues, layout) => {
  const dimensions = {
    w: layout.width,
  }

  if (layout.height > layout.width) {
    dimensions.h = layout.height
    delete dimensions.w
  }

  // query values for `width` and `height` take precedence over layout
  if (queryValues.width) {
    dimensions.w = parseInt(queryValues.width, 10)
  }

  if (queryValues.height) {
    dimensions.h = parseInt(queryValues.height, 10)

    if (!dimensions.w && typeof dimensions.w !== 'number') {
      dimensions.w = layout.width
    }
  }

  return dimensions
}

export const applyImgixParameters = (source, layout, imgixProps = {}) => {
  if (!layout) {
    return null
  }

  const uri = isObject(source) ? source.uri : source

  if (typeof uri !== 'string' || !uri.includes('imgix.net')) {
    return source
  }

  const [path, query] = uri.split(/[?#]/)
  const givenParams = query?.split('&')
  const queryValues = {}

  if (givenParams) {
    for (const param of givenParams) {
      if (param) {
        const [key, value] = param.split('=')
        queryValues[key] = value
      }
    }
  }

  const params = {
    ...getDimensions(queryValues, layout),
    dpr: Math.max(PixelRatio.get(), 2),
    auto: Platform.OS === 'web' ? 'format,compress' : 'compress',
    ...(typeof imgixProps === 'object' && { ...imgixProps }),
    ...queryValues,
  }

  const queryParams = serializeParams(params)

  if (typeof source === 'object') {
    return {
      ...source,
      uri: `${path}?${queryParams}`,
    }
  }

  return `${path}?${queryParams}`
}
